import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * <Section> — full-width section with consistent vertical rhythm.
 * Use `dark` to switch into the charcoal palette, otherwise off-white surface.
 *
 *   <Section dark>...</Section>
 *   <Section bg="white">...</Section>   // explicit pure white
 */
const Section = React.forwardRef(
    ({ className, dark = false, bg, as: Tag = "section", children, ...props }, ref) => {
        const tone = dark
            ? "bg-brand-dark text-white"
            : bg === "white"
                ? "bg-brand-white text-brand-dark"
                : "bg-brand-offwhite text-brand-dark";

        return (
            <Tag
                ref={ref}
                className={cn(
                    "w-full py-16 md:py-24",
                    tone,
                    className,
                )}
                {...props}
            >
                {children}
            </Tag>
        );
    },
);
Section.displayName = "Section";

export { Section };
